import { Box, Card, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { ShowButton, useDataProvider, useRedirect } from 'react-admin';
import { getDate } from '../../helpers/dateHelper';
import { Competition } from '../../types/competition';
import HeadTable from '../common/sortTable/sortTable';
import VisibilityIcon from '@material-ui/icons/Visibility';
import PaginationTable from '../common/paginationTable';
import { getFieldByTitle } from '../../helpers/sortByTitle';
import DateFilter from '../users/DateFilter';


interface Props {
    url: string;
    competition: string
}

interface DateState {
    startDate: Date;
    endDate: Date;
}

const CompetitionTable: FC<Props> = ({ url, competition }) => {
    const dataProvider = useDataProvider()
    const redirect = useRedirect()
    const [state, setState] = useState({
        competitions: Array<Competition>(),
        total: 0,
        page: 1,
        perPage: 10,
        field: '_id',
        order: 'desc',
    })

    const [dropdown, setDropdown] = useState({
        start: false,
        finish: false
    })

    const [filter, setFilter] = useState({
        startDate: {
            startDate: new Date("2000-01-18T19:55:00.000+00:00"),
            endDate: new Date("2030-01-18T19:55:00.000+00:00")
        },
        endDate: {
            startDate: new Date("2000-01-18T19:55:00.000+00:00"),
            endDate: new Date("2030-01-18T19:55:00.000+00:00")
        }
    })

    useEffect(() => {
        getCompetitions(1, 10, state.field, state.order, filter.startDate, filter.endDate)
    }, [])

    const filterDropdown = (title: string) => {
        const titleArray = title.toLowerCase().split(' ')
        setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] })
    }

    const getCompetitions = async (page: number, perPage: number, field: string, order: string, startDate: DateState, endDate: DateState) => {
        const competitions = await dataProvider.getList('competitions', {
            filter: {
                competition: competition,
                startDate: startDate,
                endDate: endDate
            },
            pagination: { page: page, perPage: perPage },
            sort: { field: field, order: order }
        }) as any
        setState({
            ...state,
            competitions: competitions.data,
            page: page,
            perPage: perPage,
            total: competitions.total,
            field: field,
            order: order,
        })
        setFilter({ startDate: startDate, endDate: endDate })
    }

    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const perPage = parseInt(event.target.value, 10)
        getCompetitions(1, perPage, state.field, state.order, filter.startDate, filter.endDate)
    }

    const handleLastPage = () => {
        const page = Math.ceil(state.total / state.perPage)
        getCompetitions(page, state.perPage, state.field, state.order, filter.startDate, filter.endDate)
    }

    const handleFirstPage = () => {
        getCompetitions(1, state.perPage, state.field, state.order, filter.startDate, filter.endDate)
    }

    const handleChangePage = (event: React.MouseEvent<HTMLButtonElement> | null, newPage: number): void => {
        getCompetitions(newPage + 1, state.perPage, state.field, state.order, filter.startDate, filter.endDate)
    };

    const handleSort = (order: string, title: string) => {
        let field = getFieldByTitle(title)
        getCompetitions(state.page, state.perPage, field, order, filter.startDate, filter.endDate)
    }

    const setStartStartDate = (value: Date) => {
        const startDateObject = filter.startDate
        startDateObject.startDate = value
        setFilter({ ...filter, startDate: startDateObject })
    }

    const setStartEndDate = (value: Date) => {
        const startDate = filter.startDate
        startDate.endDate = value
        setFilter({ ...filter, startDate: startDate })
    }

    const setEndStartDate = (value: Date) => {
        const endDateObject = filter.endDate
        endDateObject.startDate = value
        setFilter({ ...filter, endDate: endDateObject })
    }

    const setEndEndDate = (value: Date) => {
        const endDateObject = filter.endDate
        endDateObject.endDate = value
        setFilter({ ...filter, endDate: endDateObject })
    }
    const applyDateFilter = () => {
        getCompetitions(
            state.page,
            state.perPage,
            state.field,
            state.order,
            filter.startDate,
            filter.endDate
        )
    }

    const clearStartDateFilter = () => {
        const startDateObject = { startDate: new Date("2000-01-18T19:55:00.000+00:00"), endDate: new Date("2030-01-18T19:55:00.000+00:00") }
        setFilter({ ...filter, startDate: startDateObject })
    }

    const clearEndDateFilter = () => {
        const endDateObject = { startDate: new Date("2000-01-18T19:55:00.000+00:00"), endDate: new Date("2030-01-18T19:55:00.000+00:00") }
        setFilter({ ...filter, endDate: endDateObject })
    }

    const toDetails = (id: string) => {
        redirect(`/competition/${id}`)
    }

    const closeFilter = (e: any) => {
        setDropdown({ start: false, finish: false })
    }

    return (
        <Box marginTop="0.5em">
            <Card>
                <TableContainer>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell id="status-table-head-actions">
                                    <HeadTable title="#" sort={handleSort} />
                                </TableCell>
                                {competition === "FIXED_ODDS" ? <TableCell id="status-table-head-actions">
                                    <HeadTable title="Title" sort={handleSort} />
                                </TableCell> : null
                                }

                                <TableCell id="active-table-head">
                                    <HeadTable title="Start Date" sort={handleSort} filterHandle={filterDropdown} />
                                    {
                                        dropdown.start &&
                                        <DateFilter
                                            applyDateFilter={applyDateFilter}
                                            clearDateFilter={clearStartDateFilter}
                                            endDate={filter.startDate.endDate}
                                            startDate={filter.startDate.startDate}
                                            setStartDate={setStartStartDate}
                                            setEndDate={setStartEndDate}
                                        />
                                    }
                                </TableCell>
                                <TableCell id="active-table-head">
                                    <HeadTable title="Finish Date" sort={handleSort} filterHandle={filterDropdown} />
                                    {
                                        dropdown.finish &&
                                        <DateFilter
                                            applyDateFilter={applyDateFilter}
                                            clearDateFilter={clearEndDateFilter}
                                            endDate={filter.endDate.endDate}
                                            startDate={filter.endDate.startDate}
                                            setStartDate={setEndStartDate}
                                            setEndDate={setEndEndDate}
                                        />
                                    }
                                </TableCell>

                                <TableCell id="active-table-head">
                                    Status
                                </TableCell>
                                <TableCell id="status-table-head-actions">
                                    Actions
                                </TableCell>
                            </TableRow>
                        </TableHead>
                        {
                            state.competitions.map((item, i) => {
                                return (
                                    <TableBody onClick={closeFilter} key={i}>
                                        <TableCell>
                                            {item.competitionId}
                                        </TableCell>
                                        {
                                            competition === "FIXED_ODDS" && 
                                            <TableCell>
                                                {item.fixedOdds ? item.fixedOdds.title : 'prize deleted'}
                                            </TableCell>
                                        }
                                        <TableCell>
                                            {getDate(new Date(item.startAt))}
                                        </TableCell>
                                        <TableCell>
                                            {getDate(new Date(item.endsAt))}
                                        </TableCell>
                                        <TableCell className="base-color">
                                            {item.isActive ? "Active" : "Completed"}
                                        </TableCell>
                                        <TableCell>
                                            <Box display="flex" alignItems="center" justifyContent="center">
                                                <div className="actions-table-body">
                                                    <VisibilityIcon onClick={() => toDetails(item._id)} id="show-dreamhome" />
                                                </div>
                                            </Box>
                                        </TableCell>
                                    </TableBody>
                                )
                            })
                        }
                    </Table>
                </TableContainer>
                <PaginationTable
                    page={state.page}
                    perPage={state.perPage}
                    collectionLength={state.competitions.length}
                    total={state.total}
                    handleChangePage={handleChangePage}
                    handleLastPage={handleLastPage}
                    handleChangeRowsPerPage={handleChangeRowsPerPage}
                    handleFirstPage={handleFirstPage}
                    title="Competitions"
                />
            </Card>
        </Box>
    )
}

export default CompetitionTable

